
//import "./Home.scss";
import "../../App.scss";
import "../../assets/css/libraries.css";
import "../../assets/css/style.css";
import "../../assets/images/logo/logo-light-small.png";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar.jsx";
import ActivePatientBar from "../PatientSearch/ActivePatientBar";
// import NavLogo from "../../assets/images/logo/NavLogo.png";
// import NavLogoFooter from "../../assets/images/logo/NavLogoFooter_new.svg";
import NavLogoFooter from "../../assets/images/logo/NavLogo_footer_white.svg";
import RateCards from "./../../components/Landing/RateCards";
import { Box, Grid, Typography } from "@mui/material";

function Layout({ children, setSearchText, home }) {
  const [open, setOpen] = useState(0);
  const [search, setSearch] = useState("");

  const history = useHistory();

  return (
    <div className="wrapper" style={{ minHeight: "100dvh" }}>
      <Navbar />
      <ActivePatientBar />
      {/* {children} */}
      <main style={{ flex: 1 }}>{children}</main>
      <div className="footer">
        <Box
          className="footer-primary"
          sx={{
            px: "30px",
            py: "12px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#F4F4F4", display: "flex", alignItems: "center", gap: "6px" }}
          >
            Powered by
            <img
              src={NavLogoFooter}
              className="logo-dark logo-img"
              alt="logo"
              height="28px"
              style={{ marginLeft: "5px", verticalAlign: "middle" }}
            />
          </Typography>
        </Box>
      </div>
      {/* <button id="scrollTopBtn">
        <i className="fas fa-long-arrow-alt-up"></i>
      </button> */}

      <Helmet>
        {/* <script src="/assets/js/jquery-3.5.1.min.js"></script>
        <script src="/assets/js/plugins.js"></script>
        <script src="/assets/js/main.js"></script> */}
        <script
          src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
          type="text/javascript"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"
        />

        <link href="/assets/images/logo/logo-light-small.png" rel="icon" />
      </Helmet>
    </div>
  );
}
export default Layout;
